import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import DataPrivacyAcceptanceModal from '../../modal/DataPrivacyAcceptanceModal';
import LegalHintsModal from '../../modal/LegalHintsModal';
import TermsOfUseAcceptanceModal from '../../modal/TermsOfUseAcceptanceModal';

export type LegalModalsProps = {
    showDataPrivacyModal: boolean,
    userHasAcceptedDataPrivacy: boolean,
    showTermsOfUseModal: boolean,
    userHasAcceptedTermsOfUse: boolean
    showLegalHintsModal: boolean,
    setShowDataPrivacyModal: (show: boolean) => void,
    setShowTermsOfUseModal: (show: boolean) => void,
    setShowLegalHintsModal: (show: boolean) => void,
}
const LegalModals = (props: LegalModalsProps) => {

    const location = useLocation();
    const showLegalModals = useMemo(() => {
        const pagesWithoutLegalModals = ['terms-of-use', 'data-privacy', 'impressum', 'legal-hints', 'help', 'contact'];
        return !pagesWithoutLegalModals.some(page => location.pathname.includes(page));
    }, [location.pathname]);

    if (!showLegalModals) {
        return null;
    }
    return (<>
        <DataPrivacyAcceptanceModal
            show={!props.userHasAcceptedDataPrivacy || props.showDataPrivacyModal}
            onClose={() => props.setShowDataPrivacyModal(false)}
        />
        <TermsOfUseAcceptanceModal
            show={(!props.userHasAcceptedTermsOfUse && props.userHasAcceptedDataPrivacy) || props.showTermsOfUseModal}
            onClose={() => props.setShowTermsOfUseModal(false)}
        />
        <LegalHintsModal
            show={props.showLegalHintsModal}
            onClose={() => props.setShowLegalHintsModal(false)}
        />
    </>);
};
export default LegalModals;
